import { countries, ICountry } from '../data/countries'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function filterCountryOptions(input: string, option: any): boolean {
  if (!option) return false

  const searchTerm = input.toLowerCase()
  
  // Find the country data by ISO code (option.value)
  const countryData = countries.find((country: ICountry) => country.iso === option.value)
  
  if (countryData && countryData.searchAliases) {
    // Check if input matches any search alias
    const aliasMatch = countryData.searchAliases.some((alias: string) => 
      alias.toLowerCase().includes(searchTerm)
    )
    if (aliasMatch) return true
  }

  // Fall back to standard name search
  if (typeof option.children === 'string') {
    return option.children.toLowerCase().includes(searchTerm)
  }

  // If 'children' is an object, it means that the <IntlMessages> object has been passed in the option select. Therefore, we take the value for searching.
  if (typeof option.children === 'object') {
    return option.value.toLowerCase().includes(searchTerm)
  }
  
  return false
} 